import { parsePhoneNumberWithError } from 'libphonenumber-js';

export function formatPhone(
  phoneNumber: string,
  phoneCountryCode: string | null | undefined
): string {
  try {
    const parsed = parsePhoneNumberWithError(`${phoneCountryCode ?? ''}${phoneNumber}`);
    return parsed.formatInternational();
  } catch {
    return phoneCountryCode ? `${phoneCountryCode} ${phoneNumber}` : phoneNumber;
  }
}
